import { EmployeeInvitationStatusTypes, Subscriber, SubscriberProgress } from 'types/electionService';
import { removeSubscriber } from 'api/operations/electionService';
import { GeneralEmployeeAction } from './types';

export interface EmployeeActionObject {
  type: string;
  name: string;
  showForStatuses?: EmployeeInvitationStatusTypes[];
  showForProgress?: SubscriberProgress[];
  handler: (context: EmployeeActionContext) => Promise<void> | void;
  isMissclikable?: boolean;
}

export interface EmployeeActionContext {
  interactions: {
    setPageIsLoading: (loading: boolean) => void;
    refreshData: () => Promise<void>;
  };
  ui: {
    openSendInvitationModal: () => void;
  };
  static: { employeeData: Subscriber; groupId: string; periodId: string; cartId?: string };
}

export const generalEmployeeActions: EmployeeActionObject[] = [
  {
    type: GeneralEmployeeAction.REMOVE_EMPLOYEE,
    name: 'Remove Employee',
    isMissclikable: true,
    handler: async (context): Promise<void> => {
      context.interactions.setPageIsLoading(true);
      await removeSubscriber(context.static.employeeData.id);
      await context.interactions.refreshData();
    },
  },
];

const employeeStatusFilter =
  (employeeStatus: EmployeeInvitationStatusTypes) =>
  (actions: EmployeeActionObject[]): EmployeeActionObject[] =>
    actions.filter((action) => {
      if (!action.showForStatuses) return true;
      return action.showForStatuses.includes(employeeStatus);
    });

/** Filters actions that declare `showForProgress`; not enrollment-specific despite the historical name. */
export const enrollmentEmployeeProgressFilter =
  (employeeProgress: SubscriberProgress) =>
  (actions: EmployeeActionObject[]): EmployeeActionObject[] =>
    actions.filter((action) => {
      if (!action.showForProgress) return true;
      return action.showForProgress.includes(employeeProgress);
    });

export interface EmployeeActionPipelineSettings {
  actionList: EmployeeActionObject[];
  employeeStatus: EmployeeInvitationStatusTypes;
  employeeProgress: SubscriberProgress;
}

const composeFilters = (
  actionList: EmployeeActionObject[],
  ...filters: ((actions: EmployeeActionObject[]) => EmployeeActionObject[])[]
): EmployeeActionObject[] => filters.reduce((acc, filter) => filter(acc), actionList);

export const employeeActionsFiltersPipeline = (settings: EmployeeActionPipelineSettings): EmployeeActionObject[] =>
  composeFilters(
    settings.actionList,
    employeeStatusFilter(settings.employeeStatus),
    enrollmentEmployeeProgressFilter(settings.employeeProgress),
  );
